/**
 * Clipboard API service.
 */
import apiClient from './client';

export interface ClipboardItem {
  id: string;
  user_id: string;
  content_variants: Record<string, string>;
  title?: string;
  source?: string;
  content_type?: string;
  tags?: string[];
  ai_model_used?: string;
  theological_context?: Record<string, any>;
  character_count: number;
  word_count: number;
  sync_version: number;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

export interface CreateClipboardItemRequest {
  content_variants: Record<string, string>;
  title?: string;
  content_type?: string;
  tags?: string[];
}

export const clipboardApi = {
  async list(page: number = 1, pageSize: number = 20): Promise<{
    items: ClipboardItem[];
    total: number;
    has_more: boolean;
  }> {
    const response = await apiClient.get('/api/clipboard/items', {
      params: { page, page_size: pageSize },
    });
    return response.data;
  },

  async create(data: CreateClipboardItemRequest): Promise<ClipboardItem> {
    const response = await apiClient.post('/api/clipboard/items', data);
    return response.data;
  },

  async get(id: string): Promise<ClipboardItem> {
    const response = await apiClient.get(`/api/clipboard/items/${id}`);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/clipboard/items/${id}`);
  },
};
